import { useState, useEffect } from 'react';
import { AppProvider } from './context/AppContext';
import Sidebar from './components/Sidebar';
import BottomNav from './components/BottomNav';
import LandingPage from './pages/LandingPage';
import HuntPage from './pages/HuntPage';
import QualifyPage from './pages/QualifyPage';
import ScriptsPage from './pages/ScriptsPage';
import AIPitchPage from './pages/AIPitchPage';
import TrackerPage from './pages/TrackerPage';
import AnalyticsPage from './pages/AnalyticsPage';
import './index.css';

function AppInner() {
  const [page, setPage] = useState('hunt');
  const [showLanding, setShowLanding] = useState(true);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, []);

  const pages = {
    hunt: <HuntPage />,
    qualify: <QualifyPage />,
    pitches: <ScriptsPage />,
    ai: <AIPitchPage />,
    tracker: <TrackerPage />,
    analytics: <AnalyticsPage />,
  };

  if (showLanding) {
    return <LandingPage onEnter={() => setShowLanding(false)} />;
  }

  if (isMobile) {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
        {/* Mobile header */}
        <header style={{
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          padding: '1rem 1.25rem', borderBottom: '1px solid var(--border)',
          background: 'var(--bg2)', position: 'sticky', top: 0, zIndex: 100,
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <div style={{ width: 28, height: 28, borderRadius: 7, background: 'var(--accent)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <span style={{ fontSize: 14 }}>⚡</span>
            </div>
            <span style={{ fontFamily: 'var(--font-display)', fontWeight: 800, fontSize: 16 }}>W3Pitch</span>
          </div>
          <span style={{ fontSize: 11, fontFamily: 'var(--font-mono)', color: 'var(--text3)', background: 'var(--surface)', padding: '3px 10px', borderRadius: 20, border: '1px solid var(--border)' }}>
            {page.charAt(0).toUpperCase() + page.slice(1)}
          </span>
        </header>

        {/* Mobile content */}
        <main style={{ flex: 1, padding: '1.25rem 1rem 6rem', overflowX: 'hidden' }}>
          {pages[page]}
        </main>

        {/* Bottom nav */}
        <BottomNav active={page} setActive={setPage} />
      </div>
    );
  }

  return (
    <div style={{ display: 'flex', minHeight: '100vh' }}>
      <Sidebar active={page} setActive={setPage} />
      <main style={{ marginLeft: 220, flex: 1, padding: '2.5rem 2.5rem 0', maxWidth: 'calc(100vw - 220px)', display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
        <div style={{ flex: 1 }}>{pages[page]}</div>
        <footer style={{
          marginTop: '4rem', paddingBottom: '2rem', paddingTop: '1.5rem',
          borderTop: '1px solid var(--border)',
          display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10,
        }}>
          <img src="https://i.imgur.com/AWaMnea.jpeg" alt="" style={{ width: 36, height: 36, borderRadius: '50%', objectFit: 'cover', border: '2px solid var(--accent)' }} />
          <span style={{ fontSize: 12, fontFamily: 'var(--font-mono)', color: 'var(--text3)' }}>
            built by <span style={{ color: 'var(--accent)', fontWeight: 700 }}>adee</span>
          </span>
        </footer>
      </main>
    </div>
  );
}

export default function App() {
  return <AppProvider><AppInner /></AppProvider>;
}